// Sezioni form dello step Sopralluogo: pianificazione, rilievi tecnici, rilievi elettrici, esito
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Checkbox } from '../ui/checkbox';
import { CalendarBlank, CheckCircle, User, Lightning, Ruler } from '@phosphor-icons/react';
import { FormSection, SURVEY_OUTCOMES, TIME_SLOTS } from './SopralluogoShared';

export const PlanningSection = ({ formData, handleFieldChange, isReadOnly, internalStatus, technicians }) => (
                        <FormSection
                            title="Pianificazione Sopralluogo"
                            description="Data, ora e tecnico assegnato"
                            icon={CalendarBlank}
                            defaultOpen={internalStatus === 'DA_PIANIFICARE'}
                            badge={
                                formData.planned_date && formData.assigned_technician_id ? (
                                    <Badge variant="outline" className="text-green-600 border-green-300 text-[10px]">
                                        Completata
                                    </Badge>
                                ) : null
                            }
                        >
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <Label htmlFor="planned_date" className="text-xs font-medium">
                                        Data Sopralluogo <span className="text-red-500">*</span>
                                    </Label>
                                    <Input
                                        id="planned_date"
                                        type="date"
                                        value={formData.planned_date || ''}
                                        onChange={(e) => handleFieldChange('planned_date', e.target.value)}
                                        disabled={isReadOnly}
                                        className="text-sm"
                                    />
                                </div>
                                
                                <div className="space-y-2">
                                    <Label htmlFor="planned_time_slot" className="text-xs font-medium">
                                        Fascia Oraria
                                    </Label>
                                    <Select
                                        value={formData.planned_time_slot || ''}
                                        onValueChange={(v) => handleFieldChange('planned_time_slot', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona fascia" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {TIME_SLOTS.map(slot => (
                                                <SelectItem key={slot.value} value={slot.value}>
                                                    {slot.label}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="col-span-2 space-y-2">
                                    <Label htmlFor="assigned_technician_id" className="text-xs font-medium">
                                        Tecnico Assegnato <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.assigned_technician_id || ''}
                                        onValueChange={(v) => handleFieldChange('assigned_technician_id', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona tecnico" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {technicians.map(tech => (
                                                <SelectItem key={tech.id} value={tech.id}>
                                                    <div className="flex items-center gap-2">
                                                        <User className="h-4 w-4" />
                                                        {tech.name}
                                                        <span className="text-xs text-muted-foreground">({tech.email})</span>
                                                    </div>
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label htmlFor="site_contact_name" className="text-xs font-medium">
                                        Referente in Sito
                                    </Label>
                                    <Input
                                        id="site_contact_name"
                                        value={formData.site_contact_name || ''}
                                        onChange={(e) => handleFieldChange('site_contact_name', e.target.value)}
                                        disabled={isReadOnly}
                                        placeholder="Nome referente"
                                        className="text-sm"
                                    />
                                </div>
                                
                                <div className="space-y-2">
                                    <Label htmlFor="site_contact_phone" className="text-xs font-medium">
                                        Telefono Referente
                                    </Label>
                                    <Input
                                        id="site_contact_phone"
                                        type="tel"
                                        value={formData.site_contact_phone || ''}
                                        onChange={(e) => handleFieldChange('site_contact_phone', e.target.value)}
                                        disabled={isReadOnly}
                                        placeholder="+39..."
                                        className="text-sm"
                                    />
                                </div>
                                
                                <div className="col-span-2 space-y-2">
                                    <Label htmlFor="planning_notes" className="text-xs font-medium">
                                        Note Pianificazione
                                    </Label>
                                    <Textarea
                                        id="planning_notes"
                                        value={formData.planning_notes || ''}
                                        onChange={(e) => handleFieldChange('planning_notes', e.target.value)}
                                        disabled={isReadOnly}
                                        placeholder="Note per il tecnico..."
                                        rows={2}
                                        className="text-sm"
                                    />
                                </div>
                            </div>
                        </FormSection>
);

export const TechnicalSurveySection = ({ formData, handleFieldChange, isReadOnly, internalStatus }) => (
                        <FormSection
                            title="Rilievi Tecnici"
                            description="Dati copertura, superfici e accessibilità"
                            icon={Ruler}
                            defaultOpen={internalStatus === 'PIANIFICATO'}
                            disabled={internalStatus === 'DA_PIANIFICARE'}
                        >
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Tipologia Copertura <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.roof_type || ''}
                                        onValueChange={(v) => handleFieldChange('roof_type', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="tetto_piano">Tetto Piano</SelectItem>
                                            <SelectItem value="tetto_falda">Tetto a Falda</SelectItem>
                                            <SelectItem value="tetto_curvo">Tetto Curvo</SelectItem>
                                            <SelectItem value="pensilina">Pensilina</SelectItem>
                                            <SelectItem value="terreno">Installazione a Terra</SelectItem>
                                            <SelectItem value="altro">Altro</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Materiale Copertura
                                    </Label>
                                    <Select
                                        value={formData.roof_material || ''}
                                        onValueChange={(v) => handleFieldChange('roof_material', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="tegole">Tegole</SelectItem>
                                            <SelectItem value="coppi">Coppi</SelectItem>
                                            <SelectItem value="lamiera">Lamiera</SelectItem>
                                            <SelectItem value="guaina">Guaina/Bitume</SelectItem>
                                            <SelectItem value="cemento">Cemento</SelectItem>
                                            <SelectItem value="eternit">Eternit (bonifica)</SelectItem>
                                            <SelectItem value="altro">Altro</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Superficie Disponibile (mq) <span className="text-red-500">*</span>
                                    </Label>
                                    <Input
                                        type="number"
                                        value={formData.available_surface_mq || ''}
                                        onChange={(e) => handleFieldChange('available_surface_mq', e.target.value)}
                                        disabled={isReadOnly}
                                        placeholder="es: 50"
                                        className="text-sm"
                                    />
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Orientamento <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.roof_orientation || ''}
                                        onValueChange={(v) => handleFieldChange('roof_orientation', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="sud">Sud</SelectItem>
                                            <SelectItem value="sud_est">Sud-Est</SelectItem>
                                            <SelectItem value="sud_ovest">Sud-Ovest</SelectItem>
                                            <SelectItem value="est">Est</SelectItem>
                                            <SelectItem value="ovest">Ovest</SelectItem>
                                            <SelectItem value="piano">Piano</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Ombreggiamenti <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.shading_presence || ''}
                                        onValueChange={(v) => handleFieldChange('shading_presence', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="no">No</SelectItem>
                                            <SelectItem value="si_parziali">Sì, parziali</SelectItem>
                                            <SelectItem value="si_significativi">Sì, significativi</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Accessibilità Sito <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.site_accessibility || ''}
                                        onValueChange={(v) => handleFieldChange('site_accessibility', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="facile">Facile</SelectItem>
                                            <SelectItem value="media">Media</SelectItem>
                                            <SelectItem value="difficile">Difficile</SelectItem>
                                            <SelectItem value="richiede_mezzi_speciali">Mezzi speciali</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Condizioni Copertura <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.roof_condition || ''}
                                        onValueChange={(v) => handleFieldChange('roof_condition', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="ottime">Ottime</SelectItem>
                                            <SelectItem value="buone">Buone</SelectItem>
                                            <SelectItem value="discrete">Discrete</SelectItem>
                                            <SelectItem value="da_verificare">Da verificare</SelectItem>
                                            <SelectItem value="richiede_intervento">Richiede intervento</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">Inclinazione Falda (°)</Label>
                                    <Input
                                        type="number"
                                        value={formData.roof_inclination || ''}
                                        onChange={(e) => handleFieldChange('roof_inclination', e.target.value)}
                                        disabled={isReadOnly}
                                        placeholder="es: 30"
                                        className="text-sm"
                                    />
                                </div>
                                
                                <div className="col-span-2 grid grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                        <Label className="text-xs font-medium">Latitudine</Label>
                                        <Input
                                            value={formData.site_latitude || ''}
                                            onChange={(e) => handleFieldChange('site_latitude', e.target.value)}
                                            disabled={isReadOnly}
                                            placeholder="es: 45.4642"
                                            className="text-sm"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Label className="text-xs font-medium">Longitudine</Label>
                                        <Input
                                            value={formData.site_longitude || ''}
                                            onChange={(e) => handleFieldChange('site_longitude', e.target.value)}
                                            disabled={isReadOnly}
                                            placeholder="es: 9.1900"
                                            className="text-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </FormSection>
);

export const ElectricalSurveySection = ({ formData, handleFieldChange, isReadOnly, internalStatus }) => (
                        <FormSection
                            title="Rilievi Elettrici"
                            description="Verifica quadro elettrico e contatore"
                            icon={Lightning}
                            defaultOpen={false}
                            disabled={internalStatus === 'DA_PIANIFICARE'}
                        >
                            <div className="grid grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Quadro Elettrico <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.electrical_panel_present || ''}
                                        onValueChange={(v) => handleFieldChange('electrical_panel_present', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Presente?" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="si">Sì</SelectItem>
                                            <SelectItem value="no">No</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Contatore <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.meter_present || ''}
                                        onValueChange={(v) => handleFieldChange('meter_present', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Presente?" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="si">Sì</SelectItem>
                                            <SelectItem value="no">No</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Spazio Nuovi Componenti <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.space_for_new_equipment || ''}
                                        onValueChange={(v) => handleFieldChange('space_for_new_equipment', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="si">Sì</SelectItem>
                                            <SelectItem value="limitato">Limitato</SelectItem>
                                            <SelectItem value="no">No</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">Tipo Contatore</Label>
                                    <Select
                                        value={formData.meter_type || ''}
                                        onValueChange={(v) => handleFieldChange('meter_type', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectItem value="monofase">Monofase</SelectItem>
                                            <SelectItem value="trifase">Trifase</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                <div className="col-span-2 space-y-2">
                                    <Label className="text-xs font-medium">Note Impianto Elettrico</Label>
                                    <Textarea
                                        value={formData.electrical_notes || ''}
                                        onChange={(e) => handleFieldChange('electrical_notes', e.target.value)}
                                        disabled={isReadOnly}
                                        rows={2}
                                        className="text-sm"
                                    />
                                </div>
                            </div>
                        </FormSection>
);

export const OutcomeSection = ({ formData, handleFieldChange, isReadOnly, internalStatus }) => (
                        <FormSection
                            title="Esito Sopralluogo"
                            description="Valutazione finale e raccomandazioni"
                            icon={CheckCircle}
                            defaultOpen={internalStatus === 'PIANIFICATO'}
                            disabled={internalStatus === 'DA_PIANIFICARE'}
                        >
                            <div className="space-y-4">
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">
                                        Esito Sopralluogo <span className="text-red-500">*</span>
                                    </Label>
                                    <Select
                                        value={formData.survey_outcome || ''}
                                        onValueChange={(v) => handleFieldChange('survey_outcome', v)}
                                        disabled={isReadOnly}
                                    >
                                        <SelectTrigger className="text-sm">
                                            <SelectValue placeholder="Seleziona esito" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {SURVEY_OUTCOMES.map(outcome => (
                                                <SelectItem key={outcome.value} value={outcome.value}>
                                                    <span className={outcome.color}>{outcome.label}</span>
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </div>
                                
                                {(formData.survey_outcome === 'POSITIVO_CON_NOTE' || 
                                  formData.survey_outcome === 'CRITICITA_DA_VERIFICARE' ||
                                  formData.survey_outcome === 'NEGATIVO') && (
                                    <div className="space-y-2">
                                        <Label className="text-xs font-medium">Criticità Rilevate</Label>
                                        <Textarea
                                            value={formData.critical_issues || ''}
                                            onChange={(e) => handleFieldChange('critical_issues', e.target.value)}
                                            disabled={isReadOnly}
                                            rows={3}
                                            placeholder="Descrivi le criticità..."
                                            className="text-sm"
                                        />
                                    </div>
                                )}
                                
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                        <Label className="text-xs font-medium">Potenza Consigliata (kW)</Label>
                                        <Input
                                            type="number"
                                            step="0.1"
                                            value={formData.recommended_power_kw || ''}
                                            onChange={(e) => handleFieldChange('recommended_power_kw', e.target.value)}
                                            disabled={isReadOnly}
                                            className="text-sm"
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Label className="text-xs font-medium">Moduli Stimati</Label>
                                        <Input
                                            type="number"
                                            value={formData.estimated_modules || ''}
                                            onChange={(e) => handleFieldChange('estimated_modules', e.target.value)}
                                            disabled={isReadOnly}
                                            className="text-sm"
                                        />
                                    </div>
                                </div>
                                
                                <div className="flex flex-wrap gap-4">
                                    <div className="flex items-center gap-2">
                                        <Checkbox
                                            id="needs_technical_review"
                                            checked={formData.needs_technical_review || false}
                                            onCheckedChange={(v) => handleFieldChange('needs_technical_review', v)}
                                            disabled={isReadOnly}
                                        />
                                        <Label htmlFor="needs_technical_review" className="text-xs">
                                            Richiede revisione tecnica
                                        </Label>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Checkbox
                                            id="needs_structural_assessment"
                                            checked={formData.needs_structural_assessment || false}
                                            onCheckedChange={(v) => handleFieldChange('needs_structural_assessment', v)}
                                            disabled={isReadOnly}
                                        />
                                        <Label htmlFor="needs_structural_assessment" className="text-xs">
                                            Verifica strutturale
                                        </Label>
                                    </div>
                                </div>
                                
                                <div className="space-y-2">
                                    <Label className="text-xs font-medium">Note Finali</Label>
                                    <Textarea
                                        value={formData.survey_notes || ''}
                                        onChange={(e) => handleFieldChange('survey_notes', e.target.value)}
                                        disabled={isReadOnly}
                                        rows={3}
                                        className="text-sm"
                                    />
                                </div>
                            </div>
                        </FormSection>
);

